module.exports = __webpack_public_path__ + "static/media/leading.10d5d518.png";